export var MuiTableCellOverrides = function MuiTableCellOverrides(theme) {
  return {
    styleOverrides: {
      root: {
        borderBottom: 'none',
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        minHeight: '44px',
        padding: '0.5rem 1rem',
        '& .Mui-active.MuiTableSortLabel-root .MuiTableSortLabel-icon': {
          color: theme.palette.primary.main
        }
      }
    }
  };
};